import React from 'react';
import { FormBag, FormData, FormUpdateEvent } from 'react-formage';

import { Input } from 'components/ui/input'
import { StatusGuard } from 'components/ui/status-guard'

import { GettyAppState } from 'domains/org/getty/store'

import { FormValues, validate } from '.'

type Props = {
  readonly bag: FormBag<FormValues>;
  readonly setFormBag: React.Dispatch<React.SetStateAction<FormBag<FormValues>>>;
  readonly stopCreate: GettyAppState['stopCreate'];
};
export const StopFromScratch = ({ bag, setFormBag, stopCreate }: Props) => {
  const onUpdate = (event: FormUpdateEvent<FormValues>) => {
    setFormBag(event.bag)
  }

  return (
    <StatusGuard status={stopCreate} mode="form">
      <form noValidate onSubmit={event => {event.preventDefault()}}>
        <FormData bag={bag} onUpdate={onUpdate} validate={validate}>
          <Input
            label="Title"
            field="title"
            error={bag.touched.title ? bag.errors.title : undefined}
          />
        </FormData>
      </form>
    </StatusGuard>
  );
};
